module.exports = __webpack_public_path__ + "3d0d81d4d5229d2ab901d5e7090f731f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/10_A2.mp3
// module id = 50
// module chunks = 0